export const DEFAULT_FREE_TRIAL_DAYS = 14;